import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import FirmSettingsMain from "../Components/FirmSettings/main";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

function FirmSetting() {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();

  const [pageObject, setPageObject] = useState(null);
  const caseId = getCaseId();

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 32).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    if (caseId) {
      // Firm Settings is account-scoped, but this optional status is case-scoped.
      fetchShakespeareStatus(caseId, 32, dispatch);
    }
  }, [caseId, dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <NavBar flaggedPageName="32" />
          <FirmSettingsMain pageObj={pageObject} />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FirmSetting;
